<template>
  <div class="briefs-tab-content-view">
    <BriefContentView
      v-if="isDrilledIn"
      :brief-id="selectedBriefId"
      @onSelectedItems="$emit('onSelectedItems', $event)"
    >
      <template #breadcrumb="{ title }">
        <FolderBreadcrumb
          :breadcrumbs="[{ id: selectedBriefId, text: title || selectedBriefName }]"
          home-title="All briefs"
          @goTo="goToList"
        />
      </template>
    </BriefContentView>
    <BriefsListPane
      v-else
      band
      @select="onBriefSelected"
    />
  </div>
</template>

<script>
import FolderBreadcrumb from '@frontend/components/common/atoms/FolderBreadcrumb.vue';
import BriefContentView from './BriefContentView.vue';
import BriefsListPane from './BriefsListPane.vue';

export default {
  name: 'BriefsTabContentView',

  components: {
    BriefContentView,
    BriefsListPane,
    FolderBreadcrumb,
  },

  props: {
    defaultBriefId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      selectedBriefId: this.defaultBriefId,
      // Instant fallback for the list-click case, shown until BriefContentView's own fetch
      // resolves and the scoped-slot `title` takes over; stays blank for the defaultBriefId
      // (direct drill-in, no list row to read a name from) case.
      selectedBriefName: '',
    };
  },

  computed: {
    isDrilledIn() {
      return Boolean(this.selectedBriefId);
    },
  },

  watch: {
    // Creative Studio can stage/clear a brief while the modal is already open on this tab —
    // follow it instead of stranding the user on a brief that's no longer the active one.
    defaultBriefId(newVal) {
      this.selectedBriefId = newVal;
      this.selectedBriefName = '';
    },
  },

  methods: {
    onBriefSelected({ id, title }) {
      this.selectedBriefId = id;
      this.selectedBriefName = title;
    },

    goToList() {
      this.selectedBriefId = null;
      this.selectedBriefName = '';
      // BriefContentView unmounts via v-if; it won't emit its own selection-cleared event.
      this.$emit('onSelectedItems', []);
    },
  },
};
</script>

<style scoped>
.briefs-tab-content-view {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

</style>
